<template>
  <v-card-text class="pa-3 pa-sm-6 gamificacao-tab">
    <v-row>
      <!-- Coluna Esquerda: Saldo e Streak -->
      <v-col cols="12" lg="5">
        <!-- Card Saldo -->
        <v-card elevation="4" rounded="lg" class="mb-4" color="primary" dark>
          <v-card-title class="pb-2 responsive-card-title">
            <v-icon left :size="$vuetify.breakpoint.xs ? 22 : 28">mdi-coin</v-icon>
            <span class="text-h6 text-sm-h5">Meu Saldo</span>
          </v-card-title>
          <v-card-text class="text-center py-4 py-sm-6">
            <div class="coin-balance font-weight-bold mb-2">
              {{ saldo ? saldo.saldoTotal.toFixed(1) : '0.0' }}
              <v-icon :size="$vuetify.breakpoint.xs ? 30 : 40" color="yellow">mdi-coin</v-icon>
            </div>
            <v-divider dark class="my-3"></v-divider>
            <v-row dense class="text-center">
              <v-col cols="6">
                <div class="text-caption">Total Ganho</div>
                <div class="text-h6 success--text text--lighten-2">
                  +{{ saldo ? saldo.totalGanho.toFixed(1) : '0.0' }}
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-caption">Total Gasto</div>
                <div class="text-h6 error--text text--lighten-2">
                  -{{ saldo ? saldo.totalGasto.toFixed(1) : '0.0' }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Card Streak -->
        <v-card elevation="4" rounded="lg" class="mb-4">
          <v-card-title class="orange darken-1 white--text pb-2 responsive-card-title">
            <v-icon left color="white" :size="$vuetify.breakpoint.xs ? 22 : 28">mdi-fire</v-icon>
            <span class="text-h6 text-sm-h5">Sequência de Estudos</span>
          </v-card-title>
          <v-card-text class="py-4 py-sm-6 px-3 px-sm-4">
            <v-row dense class="text-center mb-4">
              <v-col cols="6">
                <v-card outlined>
                  <v-card-text>
                    <div class="text-caption grey--text">Sequência Atual</div>
                    <div class="streak-number font-weight-bold orange--text">
                      {{ streak ? streak.streakAtual : 0 }}
                      <v-icon color="orange" :size="$vuetify.breakpoint.xs ? 24 : 32">mdi-fire</v-icon>
                    </div>
                    <div class="text-caption">dias</div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card outlined>
                  <v-card-text>
                    <div class="text-caption grey--text">Recorde</div>
                    <div class="streak-number font-weight-bold primary--text">
                      {{ streak ? streak.streakMaximo : 0 }}
                      <v-icon color="primary" :size="$vuetify.breakpoint.xs ? 24 : 32">mdi-trophy</v-icon>
                    </div>
                    <div class="text-caption">dias</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-card color="orange lighten-5" flat class="mb-3">
              <v-card-text class="text-center">
                <div class="text-h6 orange--text text--darken-2 mb-1">
                  Bônus Atual: {{ streak ? streak.percentualBonusFormatado : '0%' }}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          small
                          color="orange darken-2"
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                      >mdi-information</v-icon>
                    </template>
                    <div style="max-width: 300px; font-size: 13px; line-height: 1.6;">
                      <div>✅ 20 coins por hora de estudo (proporcional)</div>
                      <div>✅ Bônus de Streak: 0.5% por dia (máx 15%)</div>
                      <div>✅ Bônus de Fim de Semana: 5% extra (sex, sáb, dom)</div>
                      <div>✅ Bônus de 4h: 10% sobre total do dia ao atingir 4h</div>
                    </div>
                  </v-tooltip>
                </div>
                <v-progress-linear
                  :value="progressoStreak"
                  color="orange"
                  height="10"
                  rounded
                  class="mb-2"
                ></v-progress-linear>
                <div class="text-caption grey--text">
                  {{ streak ? streak.diasParaMaximo : 30 }} dias até o bônus máximo (15%)
                </div>
              </v-card-text>
            </v-card>

            <v-alert
              :type="alertTypeStreak"
              text
              dense
              class="mb-0"
            >
              {{ streak ? streak.mensagem : 'Carregando...' }}
            </v-alert>
          </v-card-text>
        </v-card>

        <!-- Botão Loja -->
        <v-btn
          :x-large="$vuetify.breakpoint.smAndUp"
          :large="$vuetify.breakpoint.xs"
          block
          color="success"
          @click="dialogLoja = true"
          elevation="4"
          class="mb-4"
        >
          <v-icon left size="28">mdi-cart</v-icon>
          <span class="text-body-1 text-sm-h6">Ir para a Loja</span>
        </v-btn>
      </v-col>

      <!-- Coluna Direita: Histórico -->
      <v-col cols="12" lg="7">
        <v-card elevation="4" rounded="lg">
          <v-card-title class="pb-2 responsive-card-title">
            <v-icon left>mdi-history</v-icon>
            Histórico de Coins
          </v-card-title>

          <!-- Filtros -->
          <v-card-text class="pb-0">
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-menu
                  v-model="menuDataInicio"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filtroDataInicio"
                      label="Data Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtroDataInicio"
                    @input="menuDataInicio = false; filtrarHistorico()"
                    locale="pt-BR"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-menu
                  v-model="menuDataFim"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filtroDataFim"
                      label="Data Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtroDataFim"
                    @input="menuDataFim = false; filtrarHistorico()"
                    locale="pt-BR"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  block
                  color="primary"
                  @click="limparFiltros"
                  outlined
                >
                  <v-icon left small>mdi-filter-off</v-icon>
                  Limpar Filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <v-progress-linear
              v-if="carregandoHistorico"
              indeterminate
              color="primary"
            ></v-progress-linear>

            <v-list v-else-if="historico.length > 0" two-line>
              <template v-for="(item, index) in historico">
                <v-list-item :key="item.id" class="coin-history-item">
                  <v-list-item-avatar
                    :color="item.totalCoins > 0 ? 'success' : 'grey'"
                    size="48"
                  >
                    <v-icon dark>mdi-coin</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ item.temaEstudoNome }}
                      <v-chip
                        x-small
                        :color="item.ehFimSemana ? 'purple' : 'blue'"
                        dark
                        class="ml-2"
                      >
                        {{ item.duracaoFormatada }}
                      </v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ formatarData(item.dataEstudo) }}
                      <v-chip x-small class="ml-2" v-if="item.streakDias > 0">
                        <v-icon x-small left color="orange">mdi-fire</v-icon>
                        {{ item.streakDias }} dias
                      </v-chip>
                      <v-chip x-small class="ml-1" v-if="item.ehFimSemana" color="purple" dark>
                        Fim de Semana
                      </v-chip>
                      <v-chip x-small class="ml-1" v-if="item.bonus4hAplicado" color="blue" dark>
                        Bônus 4h
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <div class="text-right">
                      <div class="text-h6 success--text font-weight-bold">
                        +{{ item.totalCoins.toFixed(1) }}
                        <v-icon small color="success">mdi-coin</v-icon>
                      </div>
                      <div class="text-caption grey--text">
                        Base: {{ item.coinsBase.toFixed(1) }}
                      </div>
                      <div class="text-caption success--text" v-if="item.bonusStreak > 0">
                        Streak: +{{ item.bonusStreak.toFixed(1) }}
                      </div>
                    </div>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index < historico.length - 1" :key="`div-${item.id}`"></v-divider>
              </template>
            </v-list>

            <v-alert v-else type="info" text>
              Nenhum histórico encontrado para o período selecionado.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog Loja -->
    <v-dialog
      v-model="dialogLoja"
      max-width="1200"
      :fullscreen="$vuetify.breakpoint.xs"
      scrollable
      class="responsive-dialog"
    >
      <v-card>
        <v-card-title class="primary white--text responsive-dialog-title">
          <v-icon left color="white" :size="$vuetify.breakpoint.xs ? 22 : 28">mdi-cart</v-icon>
          <span class="text-h6 text-sm-h5">Loja de Recompensas</span>
          <v-spacer></v-spacer>
          <div class="loja-title-balance text-body-2 text-sm-h6">
            Saldo: {{ saldo ? saldo.saldoTotal.toFixed(1) : '0.0' }}
            <v-icon color="yellow">mdi-coin</v-icon>
          </div>
          <v-btn icon dark @click="dialogLoja = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Filtro por Categoria -->
        <v-card-text class="pt-4 px-3 px-sm-4">
          <v-chip-group
            v-model="categoriaFiltro"
            active-class="primary--text"
            @change="carregarItensLoja"
            mandatory
          >
            <v-chip value="">Todos</v-chip>
            <v-chip value="COMIDA">
              <v-icon left small>mdi-food</v-icon>
              Comida
            </v-chip>
            <v-chip value="BEBIDA">
              <v-icon left small>mdi-cup</v-icon>
              Bebida
            </v-chip>
            <v-chip value="PRESENTE">
              <v-icon left small>mdi-gift</v-icon>
              Presente
            </v-chip>
            <v-chip value="RECOMPENSA">
              <v-icon left small>mdi-trophy</v-icon>
              Recompensa
            </v-chip>
            <v-chip value="OUTRO">
              <v-icon left small>mdi-star</v-icon>
              Outro
            </v-chip>
          </v-chip-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="shop-items-body">
          <v-progress-linear
            v-if="carregandoLoja"
            indeterminate
            color="primary"
          ></v-progress-linear>

          <v-row v-else-if="itensLoja.length > 0">
            <v-col
              v-for="item in itensLoja"
              :key="item.id"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card elevation="2" outlined>
                <v-img
                  v-if="item.imagemUrl"
                  :src="item.imagemUrl"
                  height="150"
                  contain
                ></v-img>
                <div v-else class="empty-shop-image text-center grey lighten-3">
                  <v-icon :size="$vuetify.breakpoint.xs ? 56 : 80" color="grey">mdi-image-off</v-icon>
                </div>

                <v-card-title class="text-body-1 text-sm-h6 shop-item-title">{{ item.nome }}</v-card-title>
                <v-card-text>
                  <div class="text-body-2 mb-2">{{ item.descricao }}</div>
                  <v-chip small :color="getColorCategoria(item.categoria)">
                    {{ item.categoriaDescricao }}
                  </v-chip>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="shop-item-actions justify-space-between align-center px-3 px-sm-4">
                  <div class="text-h6 primary--text font-weight-bold">
                    {{ item.precoCoins.toFixed(1) }}
                    <v-icon color="primary">mdi-coin</v-icon>
                  </div>
                  <v-btn
                    color="success"
                    @click="abrirDialogCompra(item)"
                    :disabled="saldo && saldo.saldoTotal < item.precoCoins"
                  >
                    <v-icon left>mdi-cart-plus</v-icon>
                    Comprar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <v-alert v-else type="info" text>
            Nenhum item disponível nesta categoria.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Minhas Compras -->
        <v-card-text>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="text-body-1 text-sm-h6 purchases-title">
                  <v-icon left>mdi-package-variant</v-icon>
                  Minhas Compras
                  <v-chip small color="warning" class="ml-2" v-if="comprasPendentes.length > 0">
                    {{ comprasPendentes.length }} pendente(s)
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list v-if="compras.length > 0" two-line>
                  <template v-for="(compra, index) in compras">
                    <v-list-item :key="compra.id" class="purchase-list-item">
                      <v-list-item-avatar :color="getColorStatus(compra.status)">
                        <v-icon dark>{{ getIconStatus(compra.status) }}</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>{{ compra.nomeItem }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ formatarDataHora(compra.createdAt) }}
                          <span v-if="compra.observacao"> - {{ compra.observacao }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <div class="d-flex align-center">
                          <v-chip
                            small
                            :color="getColorStatus(compra.status)"
                            dark
                            class="mr-2"
                          >
                            {{ compra.statusDescricao }}
                          </v-chip>
                          <div class="text-body-2 mr-2">
                            {{ compra.precoPago.toFixed(1) }}
                            <v-icon small>mdi-coin</v-icon>
                          </div>
                          <v-menu offset-y v-if="compra.status === 'PENDENTE'">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" small>
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list dense>
                              <v-list-item @click="cancelarCompraSelecionada(compra.id)">
                                <v-list-item-icon>
                                  <v-icon color="error">mdi-cancel</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Cancelar</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index < compras.length - 1" :key="`div-${compra.id}`"></v-divider>
                  </template>
                </v-list>
                <v-alert v-else type="info" text dense>
                  Você ainda não fez nenhuma compra.
                </v-alert>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Confirmar Compra -->
    <v-dialog
      v-model="dialogCompra"
      max-width="500"
      :fullscreen="$vuetify.breakpoint.xs"
      scrollable
      class="responsive-dialog"
    >
      <v-card v-if="itemSelecionado">
        <v-card-title class="success white--text responsive-dialog-title">
          <v-icon left color="white">mdi-cart-check</v-icon>
          Confirmar Compra
        </v-card-title>

        <v-card-text class="pt-4 px-3 px-sm-4">
          <div class="text-center mb-4">
            <div class="text-h5 mb-2">{{ itemSelecionado.nome }}</div>
            <div class="text-body-1 grey--text mb-3">{{ itemSelecionado.descricao }}</div>
            <div class="text-h4 primary--text font-weight-bold">
              {{ itemSelecionado.precoCoins.toFixed(1) }}
              <v-icon color="primary" size="32">mdi-coin</v-icon>
            </div>
          </div>

          <v-textarea
            v-model="observacaoCompra"
            label="Observação (opcional)"
            outlined
            rows="3"
            placeholder="Ex: Para retirar no almoço, sem cebola, etc."
          ></v-textarea>

          <v-alert type="info" text dense>
            Seu saldo após a compra:
            <strong>{{ (saldo.saldoTotal - itemSelecionado.precoCoins).toFixed(1) }}</strong>
            <v-icon small>mdi-coin</v-icon>
          </v-alert>
        </v-card-text>

        <v-card-actions class="responsive-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCompra = false">Cancelar</v-btn>
          <v-btn
            color="success"
            @click="confirmarCompra"
            :loading="carregandoCompra"
          >
            <v-icon left>mdi-check</v-icon>
            Confirmar Compra
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-text>
</template>

<script>
import gamificacaoService from '@/services/gamificacaoService';
import lojaService from '@/services/lojaService';

export default {
  name: 'GamificacaoTab',

  data() {
    return {
      // Gamificação
      saldo: null,
      streak: null,
      historico: [],
      carregandoHistorico: false,

      // Filtros Histórico
      filtroDataInicio: null,
      filtroDataFim: null,
      menuDataInicio: false,
      menuDataFim: false,

      // Loja
      dialogLoja: false,
      itensLoja: [],
      carregandoLoja: false,
      categoriaFiltro: '',

      // Compras
      dialogCompra: false,
      itemSelecionado: null,
      observacaoCompra: '',
      carregandoCompra: false,
      compras: [],
      comprasPendentes: [],

      // Controle de visibilidade
      componenteVisivel: true,
    };
  },

  computed: {
    progressoStreak() {
      if (!this.streak) return 0;
      return (this.streak.streakAtual / 30) * 100;
    },

    alertTypeStreak() {
      if (!this.streak) return 'info';
      if (this.streak.streakAtual >= 30) return 'success';
      if (this.streak.streakAtual >= 15) return 'warning';
      if (this.streak.estaAtivo) return 'info';
      return 'error';
    },
  },

  mounted() {
    this.carregarDadosGamificacao();
  },

  activated() {
    // Hook chamado quando o componente é ativado (se usar keep-alive)
    this.refreshDados();
  },

  methods: {
    // Método público para atualizar dados (pode ser chamado externamente)
    refreshDados() {
      this.carregarDadosGamificacao();
    },

    async carregarDadosGamificacao() {
      try {
        await Promise.all([
          this.carregarSaldo(),
          this.carregarStreak(),
          this.carregarHistorico(),
        ]);
      } catch (error) {
        console.error('Erro ao carregar dados de gamificação:', error);
        this.$toast.error('Erro ao carregar dados de gamificação');
      }
    },

    async carregarSaldo() {
      try {
        const response = await gamificacaoService.getSaldo();
        this.saldo = response.data;
      } catch (error) {
        console.error('Erro ao carregar saldo:', error);
      }
    },

    async carregarStreak() {
      try {
        const response = await gamificacaoService.getStreak();
        this.streak = response.data;
      } catch (error) {
        console.error('Erro ao carregar streak:', error);
      }
    },

    async carregarHistorico() {
      this.carregandoHistorico = true;
      try {
        const response = await gamificacaoService.getHistorico();
        this.historico = response.data;
      } catch (error) {
        console.error('Erro ao carregar histórico:', error);
      } finally {
        this.carregandoHistorico = false;
      }
    },

    async filtrarHistorico() {
      if (!this.filtroDataInicio && !this.filtroDataFim) {
        await this.carregarHistorico();
        return;
      }

      if (this.filtroDataInicio && this.filtroDataFim) {
        this.carregandoHistorico = true;
        try {
          const response = await gamificacaoService.getHistoricoPorPeriodo(
            this.filtroDataInicio,
            this.filtroDataFim
          );
          this.historico = response.data;
        } catch (error) {
          console.error('Erro ao filtrar histórico:', error);
          this.$toast.error('Erro ao filtrar histórico');
        } finally {
          this.carregandoHistorico = false;
        }
      } else if (this.filtroDataInicio) {
        this.carregandoHistorico = true;
        try {
          const response = await gamificacaoService.getHistoricoPorData(this.filtroDataInicio);
          this.historico = response.data;
        } catch (error) {
          console.error('Erro ao filtrar histórico:', error);
          this.$toast.error('Erro ao filtrar histórico');
        } finally {
          this.carregandoHistorico = false;
        }
      }
    },

    limparFiltros() {
      this.filtroDataInicio = null;
      this.filtroDataFim = null;
      this.carregarHistorico();
    },

    async carregarItensLoja() {
      this.carregandoLoja = true;
      try {
        let response;
        if (this.categoriaFiltro && this.categoriaFiltro !== '') {
          response = await lojaService.getItensPorCategoria(this.categoriaFiltro);
        } else {
          response = await lojaService.getItens();
        }
        this.itensLoja = response.data;
      } catch (error) {
        console.error('Erro ao carregar itens da loja:', error);
        this.$toast.error('Erro ao carregar itens da loja');
      } finally {
        this.carregandoLoja = false;
      }
    },

    async carregarCompras() {
      try {
        const [comprasResponse, pendenteResponse] = await Promise.all([
          lojaService.getCompras(),
          lojaService.getComprasPendentes(),
        ]);
        this.compras = comprasResponse.data;
        this.comprasPendentes = pendenteResponse.data;
      } catch (error) {
        console.error('Erro ao carregar compras:', error);
      }
    },

    abrirDialogCompra(item) {
      this.itemSelecionado = item;
      this.observacaoCompra = '';
      this.dialogCompra = true;
    },

    async confirmarCompra() {
      this.carregandoCompra = true;
      try {
        await lojaService.comprarItem({
          itemLojaId: this.itemSelecionado.id,
          observacao: this.observacaoCompra || null,
        });

        this.$toast.success('Compra realizada com sucesso!');
        this.dialogCompra = false;

        // Recarregar dados
        await Promise.all([
          this.carregarSaldo(),
          this.carregarCompras(),
        ]);
      } catch (error) {
        console.error('Erro ao realizar compra:', error);
        const mensagem = error.response?.data?.message || 'Erro ao realizar compra';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoCompra = false;
      }
    },

    async cancelarCompraSelecionada(id) {
      if (!confirm('Deseja realmente cancelar esta compra? Os coins serão estornados.')) {
        return;
      }

      try {
        await lojaService.cancelarCompra(id);
        this.$toast.success('Compra cancelada e coins estornados com sucesso!');

        // Recarregar dados
        await Promise.all([
          this.carregarSaldo(),
          this.carregarCompras(),
        ]);
      } catch (error) {
        console.error('Erro ao cancelar compra:', error);
        const mensagem = error.response?.data?.message || 'Erro ao cancelar compra';
        this.$toast.error(mensagem);
      }
    },

    formatarData(data) {
      if (!data) return '';
      const date = this.criarDataLocal(data);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },

    formatarDataHora(data) {
      if (!data) return '';
      const date = new Date(data);
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    criarDataLocal(data) {
      if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [ano, mes, dia] = data.split('-').map(Number);
        return new Date(ano, mes - 1, dia);
      }

      return new Date(data);
    },

    getColorCategoria(categoria) {
      const cores = {
        COMIDA: 'orange',
        BEBIDA: 'blue',
        PRESENTE: 'pink',
        RECOMPENSA: 'purple',
        OUTRO: 'grey',
      };
      return cores[categoria] || 'grey';
    },

    getColorStatus(status) {
      const cores = {
        PENDENTE: 'warning',
        RESGATADA: 'success',
        CANCELADA: 'error',
      };
      return cores[status] || 'grey';
    },

    getIconStatus(status) {
      const icones = {
        PENDENTE: 'mdi-clock-outline',
        RESGATADA: 'mdi-check-circle',
        CANCELADA: 'mdi-cancel',
      };
      return icones[status] || 'mdi-help';
    },
  },

  watch: {
    dialogLoja(val) {
      if (val) {
        this.carregarItensLoja();
        this.carregarCompras();
      }
    },
  },
};
</script>

<style scoped>
.background-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.coin-balance {
  font-size: clamp(32px, 9vw, 56px);
  line-height: 1.1;
  overflow-wrap: anywhere;
}

.streak-number {
  font-size: clamp(28px, 8vw, 40px);
  line-height: 1.15;
}

.shop-items-body {
  max-height: 500px;
}

.empty-shop-image {
  padding: 32px;
}

.shop-item-title {
  line-height: 1.25;
  word-break: break-word;
}

.responsive-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.responsive-actions .v-btn {
  margin-left: 0 !important;
}

@media (max-width: 599px) {
  .gamificacao-tab {
    overflow-x: hidden;
  }

  .responsive-card-title,
  .responsive-dialog-title {
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    line-height: 1.25;
  }

  .responsive-dialog-title .spacer {
    display: none;
  }

  .loja-title-balance {
    flex: 1 1 100%;
    order: 3;
  }

  .shop-items-body {
    max-height: none;
    padding: 12px !important;
  }

  .empty-shop-image {
    padding: 24px;
  }

  .shop-item-actions,
  .responsive-actions {
    justify-content: stretch !important;
  }

  .shop-item-actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .shop-item-actions .v-btn,
  .responsive-actions .v-btn {
    flex: 1 1 100%;
  }

  .responsive-actions .spacer {
    display: none;
  }

  .coin-history-item,
  .purchase-list-item {
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 8px 0;
  }

  .coin-history-item ::v-deep .v-list-item__action,
  .purchase-list-item ::v-deep .v-list-item__action {
    flex: 1 1 100%;
    margin: 8px 0 0 56px !important;
    align-items: flex-start;
  }

  .coin-history-item ::v-deep .v-list-item__action .text-right {
    text-align: left !important;
  }

  .purchase-list-item ::v-deep .v-list-item__action > div {
    flex-wrap: wrap;
    gap: 6px;
  }

  .purchases-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
  }

  ::v-deep .v-dialog {
    margin: 8px !important;
    max-height: calc(100% - 16px) !important;
  }

  ::v-deep .v-dialog--fullscreen {
    margin: 0 !important;
    max-height: 100% !important;
  }

  ::v-deep .v-dialog .v-card__text {
    overflow-y: auto;
  }

  ::v-deep .v-chip-group .v-slide-group__content {
    flex-wrap: wrap;
  }

  ::v-deep .v-list-item__content {
    min-width: 0;
  }

  ::v-deep .v-list-item__title,
  ::v-deep .v-list-item__subtitle {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }

  ::v-deep .v-chip {
    max-width: 100%;
  }

  ::v-deep .v-chip .v-chip__content {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::v-deep .v-picker {
    width: 100%;
    max-width: 100%;
  }
}
</style>
